/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityLockClosedIcon32Regular = forwardRef('SecurityLockClosedIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M9 8a7 7 0 1 1 14 0v1a1 1 0 1 1-2 0V8a5 5 0 0 0-10 0v1a1 1 0 1 1-2 0V8Z" }),
        React.createElement("path", { d: "M18.2 18.8a2.2 2.2 0 0 1-1.2 1.96V23a1 1 0 1 1-2 0v-2.24a2.2 2.2 0 1 1 3.2-1.96Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 16a5 5 0 0 1 5-5h14a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5v-8Zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3H9Z" })));
});
